
    <!--
 * 竖版-分享给好友
 * @LastEditTime: Mon Aug 05 2024 21:41:14 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_TXC195"  :class="[`normal`,`u_c_TXC195`]" @click="u_c_TXC195_event_8HKH22($event)">{{langData.shareToFriend}}</div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{},"zh-CN":{},"zh-TW":{},"en-US":{},"ja-JP":{},"ko-KR":{},"th-TH":{},"vi-VN":{},"de-DE":{},"fr-FR":{},"ru-RU":{},"es-ES":{},"pt-PT":{},"it-IT":{},"tr-TR":{},"pl-PL":{},"id-ID":{},"ar-SA":{}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {});
const checkIsLogin = inject("checkIsLogin", () => {});
const openInvitePanel = inject("openInvitePanel", () => {});
      // 分享给好友的click事件
      const u_c_TXC195_event_8HKH22= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `分享本次活动给好友`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
await openInvitePanel();} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.zh-CN{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.zh-TW{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.en-US{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.ja-JP{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.ko-KR{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.th-TH{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.vi-VN{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.de-DE{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.fr-FR{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.ru-RU{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.es-ES{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.pt-PT{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.it-IT{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.tr-TR{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.pl-PL{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.id-ID{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}.ar-SA{
.u_c_TXC195.normal{
position:relative;
width:8.13rem;
height:1.63rem;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697640-49.png);
margin:0 auto 2.67rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.40rem;
color:#fff;
font-weight:normal;
margin-top:0.27rem;
cursor:pointer;

}
}
</style>
